<div
    class="divide-y divide-white/10 dark:divide-gray-700 overflow-hidden group rounded-lg border border-white/10 dark:border-gray-700 bg-white dark:bg-zinc-900/50 flex flex-col gap-y-2 hover:border-teal-400 dark:hover:border-teal-500 cursor-pointer">
    <div class="px-3 py-3 sm:px-4">
        <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">

            <div class="flex items-center">
                <div class="shrink-0 size-16 overflow-hidden">
                    <atom-ldg-img inputClass="object-cover" w="full" h="full" radius="full"
                        [src]="imageService.getImageSource(creator.photoURL, 'gallery_xl')"
                        [aspect]="'aspect-square'"></atom-ldg-img>
                </div>
                <div class="ml-4">
                    <div class="inline-flex gap-x-2 items-center">
                        <h3 class="text-md font-semibold text-primary">{{ creator.firstName }} {{
                            creator.lastName.charAt(0) }}</h3>
                        @if (creator.isVerified) {
                        <span class="">
                            <img class="h-4" src="../../../../../assets/social-icon/verified_badge.svg" alt="" />
                        </span>
                        }
                    </div>

                    <p class="text-sm text-secondary">
                        {{ formatService.getFlag(creator) }} {{ creator.homeTownName ? creator.homeTownName : 'Unset' }}
                    </p>
                </div>
            </div>

            <div class="flex flex-row shrink-0 items-center justify-start h-full">

                @if (isSelected()) {
                <button type="button" (click)="removeCreator()"
                    class="inline-flex items-center gap-x-1.5 secondary-button text-primary">
                    Un-Select
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="-mr-0.5 size-5">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                </button>
                } @else {
                <button type="button" (click)="selectCreator()"
                    class="inline-flex items-center gap-x-1.5 primary-button">
                    Collaborate
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="-mr-0.5 size-5">
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                </button>
                }
            </div>
        </div>
    </div>
    <div class="p-2 flex flex-col gap-y-4">
        <!-- About Row -->
        @if (creator.bio) {
        <div class="flex flex-col w-full justify-start items-start">
            <h4 class="text-sm font-bold text-primary">About</h4>
            <p class="text-xs text-secondary line-clamp-2 h-[2lh]">{{ creator.bio }}</p>
        </div>
        }
        <!-- About Row -->

        <!-- Reviews Row -->
        @if (creatorResult.reviews_summary && creatorResult.reviews_summary.average_rating) {
        <div class="flex flex-col w-full justify-start items-start">
            <h4 class="text-sm font-bold text-primary">Reviews</h4>
            <div class="mt-1 flex flex-row w-full items-center justify-between">

                <div class="flex flex-row items-center gap-x-2">
                    <p
                        class="bg-blue-100 text-blue-800 text-sm font-semibold inline-flex items-center p-1.5 rounded dark:bg-blue-900/30 dark:text-blue-300">
                        {{ creatorResult.reviews_summary.average_rating | number:'1.1-1' }}</p>
                    <p class="ms-2 font-medium text-primary">{{
                        getKudosWord(creatorResult.reviews_summary.average_rating) }}</p>
                    <span class="w-1 h-1 mx-2 bg-gray-900 rounded-full dark:bg-gray-400"></span>
                    <p class="text-xs font-medium text-secondary">{{
                        creatorResult.reviews_summary.total_reviews }} {{
                        creatorResult.reviews_summary.total_reviews == 1 ? 'review' : 'reviews'
                        }}</p>
                    <a class="ms-auto text-sm font-medium text-blue-600 hover:underline dark:text-blue-400"></a>
                </div>

                <div
                    class="p-1 bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20 rounded-lg flex flex-row items-center justify-center gap-1.5 group dark:bg-green-900/20 dark:text-green-400 dark:ring-green-500/30">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-4">
                        <path d="M7 10v12" />
                        <path
                            d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                    </svg>
                    <p class="text-xs font-medium">
                        {{ creatorResult.reviews_summary.recommend | number:'1.0-0' }}% Would Recommend</p>
                </div>
            </div>
        </div>
        }
        <!-- Reviews Row - END -->


        <!-- Social Aggregations Row -->
        <!-- <div class="flex flex-col w-full justify-start items-start">
            <h4 class="text-sm font-bold text-primary">Socials Overview</h4>
            <div class="mt-1 flex flex-col justify-between w-full h-full">
                <dl class="grid grid-cols-3 gap-2 sm:gap-4">
                    <div class="overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-800/50 px-2 py-1 sm:px-4">
                        <dt class="truncate text-[10px] sm:text-xs font-medium text-secondary">Total Followers</dt>
                        <dd class="text-sm sm:text-lg font-semibold tracking-tight text-primary">{{
                            formatService.convertIntToString(creator.tikTokFollowers + creator.instaFollowers +
                            creator.snapchatFollowers + creator.youtubeSubscribers) }}</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-800/50 px-2 py-1 sm:px-4">
                        <dt class="truncate text-[10px] sm:text-xs font-medium text-secondary">Avg. Views</dt>

                        <dd class="text-sm sm:text-lg font-semibold tracking-tight text-primary">{{
                            formatService.convertIntToString(
                            getAverageViews()
                            ) }}</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-800/50 px-2 py-1 sm:px-4">
                        <dt class="truncate text-[10px] sm:text-xs font-medium text-secondary">Avg. Engagement</dt>
                        <dd class="text-sm sm:text-lg font-semibold tracking-tight text-primary">{{ getAvgEngaegement()
                            |
                            number:
                            '1.2-2' }}%</dd>
                    </div>
                </dl>
            </div>
        </div> -->
        <!-- Social Aggregations Row - END -->

        <div class="flex flex-col w-full justify-start items-start">
            <h4 class="text-sm font-bold text-primary">Socials & Video Preview</h4>
            <div class="w-full grid grid-cols-3 gap-4">
                <div class="col-span-1 flex flex-col items-start justify-center rounded-lg  p-4 space-y-4">

                    <div class="w-full flex rounded-md">
                        <div
                            class="flex size-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-primary border-t border-l border-b border-white/10">
                            <img class="h-8 w-8" src="../../../../../assets/social-icon/tik-tok-transparent.svg"
                                alt="TikTok">
                        </div>
                        <div
                            class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-white/10">
                            <div class="flex-1 truncate px-4 py-2 text-sm">
                                <a class="font-medium text-primary">{{ (creator.tikTokFollowers &&
                                    creator.tikTokFollowers > 0) ?
                                    (creator.tikTokFollowers |
                                    shortNumber) : '-' }}</a>
                                <p class="text-secondary">TikTok</p>
                            </div>

                        </div>
                    </div>

                    <div class="w-full flex rounded-md">
                        <div
                            class="flex size-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-primary border-t border-l border-b border-white/10">
                            <img class="h-8 w-8" src="../../../../../assets/social-icon/instagram-logo.png"
                                alt="TikTok">
                        </div>
                        <div
                            class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-white/10">
                            <div class="flex-1 truncate px-4 py-2 text-sm">
                                <a class="font-medium text-primary">{{ (creator.instaFollowers &&
                                    creator.instaFollowers > 0) ?
                                    (creator.instaFollowers |
                                    shortNumber) : '-' }}</a>
                                <p class="text-secondary">Instagram</p>
                            </div>

                        </div>
                    </div>

                    <div class="w-full flex rounded-md">
                        <div
                            class="flex size-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-primary border-t border-l border-b border-white/10">
                            <img class="h-8 w-8" src="../../../../../assets/social-icon/snapchat-logo.svg" alt="TikTok">
                        </div>
                        <div
                            class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-white/10">
                            <div class="flex-1 truncate px-4 py-2 text-sm">
                                <a class="font-medium text-primary">{{
                                    (creator.snapchatFollowers && creator.snapchatFollowers > 0) ?
                                    (creator.snapchatFollowers |
                                    shortNumber) :
                                    '-'
                                    }}</a>
                                <p class="text-secondary">Snapchat</p>
                            </div>

                        </div>
                    </div>
                </div>

                <div
                    class="col-span-2 flex flex-row items-center justify-between rounded-lg bg-gray-100 dark:bg-gray-800/50 p-4 space-x-4">
                    @if (matchedPreviewVideos.length > 0) {
                    <ul role="list" class="grid grid-cols-3 gap-x-2 gap-y-4 w-full">
                        @for (matched of matchedPreviewVideos.slice(0, 3); track $index) {
                        <li class="relative">
                            <div
                                class="w-full aspect-9/16 overflow-hidden rounded-lg cursor-pointer group bg-gray-100 focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary">
                                <atom-video-thumbnail [videoUrl]="matched.videoFile.s3_url"
                                    [thumbnailURL]="matched.videoFile.cover && matched.videoFile.cover.length !== '' ? matched.videoFile.cover : undefined"
                                    [videoFormat]="VideoFormatEnum.Vertical"
                                    [thumb_cdn_size]="'gallery'"></atom-video-thumbnail>
                                <!-- (click)="openViewer($event)"></vs-video-thumbnail> -->
                            </div>
                        </li>
                        }
                    </ul>
                    }
                </div>
            </div>
        </div>


    </div>
</div>